import { DotsVerticalIcon } from '@iconicicons/react';
import React from 'react';

export type DropdownMenuProps = React.PropsWithChildren<{}>;

export const DropdownMenu: React.FC<DropdownMenuProps> = (props) => {
  return (
    <div className="dropend">
      <DotsVerticalIcon
        type="button"
        className="dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        width={32}
      />
      <ul className="dropdown-menu flex-column gap-1">{props.children}</ul>
    </div>
  );
};
